module.exports = __webpack_public_path__ + "img/组 127.310a7c99.png";